var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center",staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"width":"200px","height":"200px"}},[_c('animal-poly')],1),_c('div',[_vm._v("모델을 불러오는 중...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }